import React from 'react';
import { shape, arrayOf, any, object, bool, string } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Field, FieldArray, getIn } from 'formik';
import Typography from '@material-ui/core/Typography';

import FormikUploadButton from '../core/formik/FormikUploadButton';
import FileThumbnail from '../core/FileThumbnail';

import { SUPPORTED_FORMATS } from '../../config';
import startupConfig from '../../config/startupConfig';
import { FormHelperText } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  placeholder: {
    display: 'grid',
    gridTemplateColumns: '2fr 8fr 2fr',
    alignItems: 'center',
    borderRadius: '4px',
    padding: '8px',
  },
  error: {
    border: `1px solid ${theme.palette.error.main}`,
  },
  uploadButton: {
    margin: '24px 0 12px',
  },
  subtitle: {
    margin: '12px 0 4px',
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      lineHeight: 1.4,
    },
  },
  attachTrustDeedText: {
    fontSize: 14,
  },
  subtitle3: {
    color: theme.palette.grey.dark,
    fontSize: 12,
  },
}));

const DeedFileForm = ({ values, errors, isRequired, name, filesLengthError, touched }) => {
  const classes = useStyles();

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <React.Fragment>
          <Grid item xs={12}>
            <Typography variant="subtitle1" className={classes.subtitle}>
              {`We need your trust deed to verify some details${
                !isRequired ? ', you can upload this now or later' : ''
              }`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" className={classes.attachTrustDeedText}>
              {`Attach trust deed${!isRequired ? ' (Optional)' : ''}`}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" className={classes.subtitle3}>
              The file you upload can be in PDF, JPG or PNG format. It cannot be larger than{' '}
              {startupConfig.get().trustDeedAttachment.maxFileSizeInMb}MB.
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.uploadButton}>
            <Field
              name={name}
              component={FormikUploadButton}
              label={values[name].length ? 'Add Another File' : 'Add File'}
              accept={SUPPORTED_FORMATS.toString()}
              data-testid="addfile"
              showNoError
            />
            {filesLengthError && touched[name] && (
              <FormHelperText error variant="filled">
                {filesLengthError}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12}>
            {values[name] && values[name].length > 0 && (
              <div data-testid="uia-filelist">
                {values[name].map((file, index) => {
                  const fileErrors = Array.isArray(errors[name]) && getIn(errors, name);
                  const error =
                    fileErrors && fileErrors.length > index && fileErrors[index].length > 1
                      ? fileErrors[index]
                      : null;
                  return (
                    file && (
                      <FileThumbnail
                        file={file}
                        error={error}
                        onDelete={() => {
                          arrayHelpers.remove(index);
                        }}
                      />
                    )
                  );
                })}
              </div>
            )}
          </Grid>
        </React.Fragment>
      )}
    />
  );
};

DeedFileForm.propTypes = {
  values: shape({
    files: arrayOf(any),
  }),
  errors: object,
  touched: object,
  isRequired: bool,
  name: string,
  filesLengthError: string,
};

DeedFileForm.defaultProps = {
  values: {},
  errors: {},
  touched: {},
  isRequired: false,
  name: 'files',
  filesLengthError: null,
};

export default DeedFileForm;
